// extracted by css-extract-rspack-plugin
export default {"cls1":"SearchOnboardingOverhaul-cls1_tQ3","cls2":"SearchOnboardingOverhaul-cls2_qDT SearchOnboardingOverhaul-cls1_tQ3"};